import { TEXT_COLOR, TRANSPARENT_COLOR } from './constants';
export var textFormatter = function (text) {
    return text.replace(/^\w/, function (c) { return c.toUpperCase(); });
};
export var generateTextColor = function (isTransparent) {
    return isTransparent ? TRANSPARENT_COLOR : TEXT_COLOR;
};
